import { render, staticRenderFns } from "./videoHeadline.vue?vue&type=template&id=3c7a8e86&scoped=true&"
import script from "./videoHeadline.vue?vue&type=script&lang=js&"
export * from "./videoHeadline.vue?vue&type=script&lang=js&"
import style0 from "./videoHeadline.vue?vue&type=style&index=0&id=3c7a8e86&lang=less&scoped=true&"
import style1 from "./videoHeadline.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a8e86",
  null
  
)

component.options.__file = "videoHeadline.vue"
export default component.exports